import { useQuery } from '@tanstack/react-query';
import axios from '../services/axiosInstance';

type Params = {
  qs:            string;
  locationName?: string;
  isRegion:      boolean;
  enabled:       boolean;
};

const fetcher = (url: string) => axios.get(url).then(r => r.data);

export const useRegionOverview = ({ qs, enabled, isRegion }: Params) =>
  useQuery({
    queryKey: ['gbp', 'region-overview', qs],
    queryFn:  () => fetcher(`/api/gbp/performance/region-overview?${qs}`),
    enabled:  enabled && isRegion && !!qs,
  });

export const useRegionReviews = ({ qs, enabled, isRegion }: Params) =>
  useQuery({
    queryKey: ['gbp', 'region-reviews', qs],
    queryFn:  () => fetcher(`/api/gbp/performance/region-reviews?${qs}`),
    enabled:  enabled && isRegion && !!qs,
  });

export const useFicheFull = ({ qs, locationName, enabled, isRegion }: Params) =>
  useQuery({
    queryKey:  ['gbp', 'fiche-full', qs],
    queryFn:   () => fetcher(`/api/gbp/performance/fiche-full?${qs}`),
    enabled:   enabled && !isRegion && !!locationName && !!qs,
    staleTime: 1000 * 60 * 15,
  });